export type QuerySetState = Record<string, string>;

export function getQuerySetInitialState(): QuerySetState {
  return {};
}
